import { useState, useEffect } from 'react';
import { ScrapbookFolder } from '@/api';
import FolderTreeView from '../sidebar/FolderTreeView';
import XLight from '@/assets/xLight.svg';
import Modal from '../../general/Modal';

interface CopyMoveDialogProps {
  show: boolean;
  folders: ScrapbookFolder[];
  onOk: (folder: ScrapbookFolder) => void;
  onCancel: () => void;
}

export default function CopyMoveDialog({ show, folders, onOk, onCancel }: CopyMoveDialogProps) {
  const [selectedFolder, setSelectedFolder] = useState<ScrapbookFolder | null>(null);
  const [selectedFolderId, setSelectedFolderId] = useState(0);
  const [filteredFolders, setFilteredFolders] = useState<ScrapbookFolder[]>([]);

  useEffect(() => {
    if (show && folders.length > 0) {
      const root = folders[0];
      const newRoot = { ...root };
      const nonSharedChildren = newRoot.children?.filter((fldr) => !fldr.isShared) || [];
      newRoot.children = nonSharedChildren;
      setFilteredFolders([newRoot]);
      setSelectedFolder(root);
      setSelectedFolderId(root.id);
    }
  }, [show, folders]);

  const handleFolderSelect = (folder: ScrapbookFolder) => {
    setSelectedFolder(folder);
    setSelectedFolderId(folder.id);
  };

  const handleOk = () => {
    if (selectedFolder) {
      const folder = selectedFolder === filteredFolders[0] ? folders[0] : selectedFolder;
      onOk(folder);
    }
  };

  return (
    <Modal open={show} onClose={onCancel} contanerClassName="w-[500px] max-w-[90vw] bg-white shadow-xl">
      <div className="flex items-center justify-between p-4">
        <h3 className="text-lg font-medium text-gray-900">Select destination folder</h3>
        <XLight className="h-6 w-6 cursor-pointer hover:bg-gray-100" onClick={onCancel} />
      </div>
      <div className="p-4">
        <div className="max-h-64 overflow-y-auto" data-lenis-prevent>
          <FolderTreeView
            folders={filteredFolders}
            selectedFolderId={selectedFolderId}
            onFolderSelect={handleFolderSelect}
            draggingEnabled={false}
          />
        </div>
      </div>
      <div className="flex justify-end gap-3 rounded-b-lg bg-gray-50 p-4">
        <button
          onClick={handleOk}
          className="hover:bg-black-700 h-10 min-w-[71px] cursor-pointer rounded-3xl bg-black px-4 py-2 text-white"
        >
          Ok
        </button>
        <button
          onClick={onCancel}
          className="hover:bg-gray-3 h-10 min-w-[90px] cursor-pointer rounded-3xl bg-[#f5f5f5] px-4 py-2 text-gray-700 transition-all duration-300 ease-in-out hover:scale-105 hover:text-gray-900 hover:shadow-md"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
}
